import { CustomerAnalyticsHitEventTypeEnum } from '.spec/self-care/tsTypes';
import React from 'react';

import AccountTrackCreateMutation from 'mutations/AccountTrackCreateMutation.graphql';

import { JarabotTrackingProvider } from './JarabotTrackingProvider';

const PLATFORM = process.env.MOB_APP_BUILD ? 'mobapp' : 'web';

export function JarabotSelfCareTrackingProvider({
	children,
}: {
	children: React.ReactNode;
}): JSX.Element {
	return (
		<JarabotTrackingProvider
			mutation={AccountTrackCreateMutation}
			buildVariables={({ promotionId, screenName }) => ({
				body: {
					eventType: CustomerAnalyticsHitEventTypeEnum.CHAT_SUPPORT_OPEN,
					screenName,
					extraData: {
						trigger: promotionId,
						platform: PLATFORM,
						userAgent: navigator.userAgent,
					},
				},
			})}
		>
			{children}
		</JarabotTrackingProvider>
	);
}
